import {
    Container,
    StyledCopyNextLayer,
    StyledInputLayer,
    StyledNoteLayer,
} from "./Cell.styles";
import { useEffect, useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";
import { formModes } from "shared/constants/allocationsEnums";

const Cell = ({
    employee,
    project,
    value,
    onChange,
    onUpdate,
    onHover,
    onMouseDown,
    onAdjustStart,
    onAdjustEnd,
    dragged,
    date,
    maxValue,
    minValue,
    stepValue,
    hasNotes,
    noteText,
    onAddRemoveNote,
    resizeMaxValue,
    onClick,
    typing,
    tabIndex,
    cellKey,
    readOnly,
    userHasNotesAccessToAddEdit,
    userHasNotesAccessToView,
    onUpdateNote,
    onCopyHours,
}) => {
    const [currentValue, setCurrentValue] = useState(null);

    const getCappedValueWithMax = (value, maxVal) =>
        Math.min(Math.max(value, minValue), maxVal);

    const changeValue = (event, value) => {
        setCurrentValue(barValue(value));
        onChange(event, getCappedValueWithMax(value, maxValue), true);
    };

    const handleClick = (event) => {
        if (!readOnly) {
            onClick(event);
        }
    };

    const handleMouseEnter = (event) => {
        if (!readOnly) {
            onHover(event);
        }
    };

    const handleUpdate = (event, currentValue) => {
        if (!readOnly) {
            setCurrentValue(barValue(currentValue));
            onUpdate(event, currentValue);
        }
    };

    const barValue = (v) => {
        const calc = Math.min((v * 100) / 40, 100);
        return calc + "%";
    };

    const updateValue = (e, v) => {
        setCurrentValue(barValue(v));
    };

    useEffect(() => {
        setCurrentValue(barValue(value));
    }, [value]);

    return (
        <Container
            onMouseEnter={(event) => handleMouseEnter(event)}
            onMouseDown={onMouseDown}
            onClick={handleClick}
            typing={typing && !dragged}
            dragged={dragged}
            tabIndex={tabIndex}
            id={"cellContainer_" + cellKey}
            $readOnly={readOnly}
        >
            <div
                id={"cellLoading_" + cellKey}
                style={{
                    position: "absolute",
                    top: "4px",
                    left: "0.3125rem",
                    display: "none",
                    zIndex: "1100",
                }}
            >
                <CircularProgress
                    style={{
                        color: globalThis.config.colors.gray2,
                        height: "14px",
                        width: "14px",
                    }}
                />
            </div>
            <div
                style={{
                    position: "absolute",
                    bottom: "0px",
                    height: currentValue,
                    width: "100%",
                    backgroundColor: "#E1EEFF",
                }}
            >
                &nbsp;
            </div>
            <StyledInputLayer
                value={value}
                onChange={(event) => changeValue(event, event.target.value)}
                editable={!readOnly && typing}
                onUpdate={(event) => handleUpdate(event, event.target.value)}
                onFocus={(event) => updateValue(event, event.target.value)}
                tabIndex={tabIndex}
                projectId={project.jobId}
            />
            {!typing && (
                <>
                    {!readOnly && (
                        <StyledCopyNextLayer
                            onClick={(e) => onCopyHours(e, tabIndex)}
                        />
                    )}
                    {((userHasNotesAccessToAddEdit &&
                        (value > 0 || hasNotes)) ||
                        (userHasNotesAccessToView && hasNotes)) && (
                        <StyledNoteLayer
                            mode={
                                hasNotes
                                    ? formModes.DETAIL
                                    : userHasNotesAccessToAddEdit &&
                                      formModes.ADD
                            }
                            readOnly={
                                !userHasNotesAccessToAddEdit &&
                                userHasNotesAccessToView
                            }
                            date={date}
                            hasNotes={hasNotes}
                            noteText={noteText}
                            onAddRemoveNote={onAddRemoveNote}
                            employee={employee}
                            project={project}
                            cellCount={employee.weeks.length}
                            tabIndex={tabIndex}
                            onUpdateNote={onUpdateNote}
                        />
                    )}
                </>
            )}
        </Container>
    );
};

Cell.defaultProps = {
    value: 0,
    minValue: 0,
    maxValue: 40,
    stepValue: 1,
    onChange: () => void 0,
    onHover: () => void 0,
    onAdjustStart: () => void 0,
    onAdjustEnd: () => void 0,
    onAddRemoveNote: () => void 0,
    resizeMaxValue: 120,
};

Cell.propTypes = {
    employee: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func,
    onUpdate: PropTypes.func.isRequired,
    onHover: PropTypes.func,
    onMouseDown: PropTypes.func,
    onAdjustStart: PropTypes.func,
    onAdjustEnd: PropTypes.func,
    dragged: PropTypes.bool.isRequired,
    date: PropTypes.string.isRequired,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    stepValue: PropTypes.number,
    hasNotes: PropTypes.bool.isRequired,
    noteText: PropTypes.string,
    onAddRemoveNote: PropTypes.func,
    resizeMaxValue: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    typing: PropTypes.bool.isRequired,
    tabIndex: PropTypes.number.isRequired,
    cellKey: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    userHasNotesAccessToAddEdit: PropTypes.bool.isRequired,
    userHasNotesAccessToView: PropTypes.bool.isRequired,
    onUpdateNote: PropTypes.func.isRequired,
    onCopyHours: PropTypes.func.isRequired,
};

export default Cell;
